import { faDownload, faEdit, faEye, faMinusSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DicomViewModal from 'components/Dicom/DicomViewModal'
import ImageViewModal from 'components/Modals/ViewImage.modal'
import Toolbar from 'components/Toolbar/Toolbar'
import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { ExamServices } from 'Services/examServices'

interface IQuestionImageTable {
    data: any
    reload: any
    questionId: string
    questionAsImage?:boolean
}

const QuestionImageTable = ({ data, reload, questionId, questionAsImage = false }: IQuestionImageTable) => {

    const [s3Link, setS3Link] = useState<string>();
    const [selectedImage, setSelectedImage] = useState<any>(undefined);



    function downloadURI(uri: string, name: string) {
        let link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

    const deleteQuestionImageByQuestionDataId = async (questionDataId: any) => {
        if (!questionAsImage) {
            await ExamServices.deleteQuestionImageByQuestionDataId(data._id, questionDataId, questionId).then(res => {
                if (res.status === 200) {
                    toast.success("Deleted")
                    reload();
                }
            }).catch(e => {
                console.error(e);
                toast.error("something went wrong");
            })
        } else {
            await ExamServices.deleteQuestionDataAsImage(data._id, questionDataId, questionId).then(res => {
                if (res.status === 200) {
                    toast.success("Deleted")
                    reload();
                }
            }).catch(e => {
                console.error(e);
                toast.error("something went wrong");
            })
        }
    }

    const getS3Link = async() => {
        await ExamServices.getS3Link().then((res) => {
            if(res.status === 200){
                setS3Link(res.data.s3Url);
            }
        })
    }
    
    async function getCache(link: string) {
        const body = await fetch(link, { cache: "force-cache" })
        downloadURI(await body.text(), "file-data.zip");
    }

    async function downloadImage (imageUrl:string){
        const url = s3Link+"/"+imageUrl;
        const body = await fetch(url);
        const image_data = await body.text();
        setSelectedImage(image_data);
    }  

    useEffect(() =>{
        getS3Link();
    },[])



    return (
        <>
            <h5>Language:- {data.language.toUpperCase()}</h5>

            <ImageViewModal
                 show={selectedImage?true: false}
                 setShow={() => setSelectedImage(undefined)}
                 imageData={selectedImage}
            />

            <Table striped borderless className="xrg-table" size="sm" responsive="md">
                <thead>
                    <tr>
                        <th>Question id</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data && data.questionData.map((question: any) => {
                        return (
                            <>
                                <tr>
                                    <td>{question}</td>
                                    <td>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <Toolbar
                                                values={
                                                    [
                                                        {
                                                            value: <>
                                                                <FontAwesomeIcon icon={faEye} size="sm" className="me-2" />
                                                                View Image
                                                            </>,
                                                            onClick: () => {
                                                                downloadImage(question)
                                                            },
                                                            variant: "secondary"
                                                        },

                                                        {
                                                            value: <>
                                                                <FontAwesomeIcon icon={faMinusSquare} size="sm" className="me-2" />
                                                                Delete
                                                            </>,
                                                            onClick: () => deleteQuestionImageByQuestionDataId(question),
                                                            variant: "danger"
                                                        }
                                                    ]
                                                }
                                                size="sm"
                                            />
                                        </div>
                                    </td>
                                </tr>

                            </>
                        )
                    })}

                </tbody>
            </Table>
        </>
    )
}

export default QuestionImageTable